import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-array/src/zip.js
// module id = ../../../../d3-array/src/zip.js
// module chunks = vendor